import { sagas as usersSagas } from './modules/users'
import { sagas as inviteUserSagas } from './modules/inviteUser'

export default [...usersSagas, ...inviteUserSagas]
